module.exports = __webpack_public_path__ + "static/media/img2.c028a566.jpg";